import React, { FormEvent, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import SearchComponent from '../../components/atoms/Search'
import useSearch from '../../hooks/queries/useSearch'

function Search() {
  const location = useLocation()
  const searchInputRef = useRef<HTMLInputElement>(null)
  const { setSearchValue } = useSearch()

  const onSearch = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    const value = searchInputRef.current?.value
    setSearchValue(value)
  }

  return <SearchComponent ref={searchInputRef} onSearch={onSearch} animated={location.pathname === '/'} />
}

export default Search
